import { isPresent } from 'utils/isPresent';
import React, { useCallback } from 'react'
import PropTypes from "prop-types"
import { useDispatch } from 'react-redux'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { trackButtonClicked } from "../../../Services/Analytics/TrackEventsService.js"
import { getApplicationUrl } from '../Redux/Actions.js'

const WisetackButton = ({ buttonLocation, applicationUrl, usePendingLanguage }) => {
  const dispatch = useDispatch()
  const onButtonClick = useCallback(() => {
    dispatch(trackButtonClicked('apply now', {button_location: buttonLocation}))
    if (isPresent(applicationUrl)) {
      window.open(applicationUrl, '_blank')
    } else {
      dispatch(getApplicationUrl())
    }
  }, [])

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onButtonClick}
    >
      {usePendingLanguage ? 'Complete Setup' : 'Apply Now'}
    </Button>
  )
}

WisetackButton.propTypes = {
  buttonLocation: PropTypes.string.isRequired
}

export default WisetackButton
